/** Message keys owned by the orders module. */
import { defineMessages } from '@daka/core';

export const ORDER_MESSAGES = defineMessages('orders', [
   'moduleTitle',
   'navOrders',
   'navCalendar',

   'orderNotFound',
   'orderLocked',
   'orderNotDraft',
   'orderNotCompleted',
   'orderNotRevertable',
   'submitFailed',
   'linesInvalid',
   'importNotFound',
   'importEmpty',
   'orderEmpty',

   'statusDraft',
   'statusCompleted',
   'statusSubmitted',
   'statusConfirmed',
   'statusRejected',

   'ordersTitle',
   'ordersEmpty',
   'deleteOrderConfirm',
   'backToOrders',
   'completeOrder',
   'sendOrder',
   'sendOrderConfirm',
   'revertOrder',
   'revertOrderConfirm',
   'linesEmpty',
   'columnSku',
   'columnDescription',
   'columnQuantity',
   'columnUnitPrice',
   'columnCurrency',
   'columnCustomerRef',
   'columnDeliveryDate',

   'fieldSupplier',
   'fieldContactPerson',
   'fieldSeason',
   'fieldLocation',
   'fieldBuyer',
   'fieldBrand',
   'fieldSubSeason',
   'fieldAssortment'
] as const);
